<template>
    <v-flex class="commeted_users" xs12>
        <v-card>
            <v-flex class="commeted_users__inner__scroll">
                <v-flex class="commeted_users__close">
                    <v-btn flat icon data-qe-id="close_dialog_btn" @click="closeDialog()">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-flex>
                <v-flex v-for='(commentedUser,index) in commentedUsers' :key="index">
                    <v-list two-line class="commeted_users__list">
                        <v-list-tile>
                            <v-list-tile-avatar>
                                <img :src="commentedUser.userProfileImageUrl"
                                    :onerror="imageErrorFallback(commentedUser.fallbackProfileImageUrl)">
                            </v-list-tile-avatar>
                                <v-list-tile-content>
                                    <v-list-tile-title bold>
                                        <strong v-if="commentedUsers.length === 1"
                                                @click="!showMemberProfile ? openMemberProfile(commentedUser.id): null"
                                                class="text-truncate"
                                                data-qe-id="launch_member_profile_link_one"
                                                :class="{'pointer': !showMemberProfile}">
                                            {{commentedUser.firstName}} {{commentedUser.lastName}}
                                        </strong>
                                        <strong v-if="commentedUsers.length > 1"
                                                @click="openMemberProfile(commentedUser.id)"
                                                data-qe-id="launch_member_profile_link_two"
                                                class="text-truncate pointer">
                                            {{commentedUser.firstName}} {{commentedUser.lastName}}
                                        </strong>
                                    </v-list-tile-title>
                                    <v-list-tile-sub-title class="chapter_unitTest" data-qe-id="commented_member_chapter_name">
                                        {{commentedUser.chapter}}
                                    </v-list-tile-sub-title>
                                </v-list-tile-content>
                        </v-list-tile>
                        <v-btn v-if="showMemberProfile"
                               @click="openMemberProfile(commentedUser.id)"
                               data-qe-id="view_commented_member_profile_link"
                               class="button">
                            {{communityCommonConstant.commented_Users.VIEW_PROFILE}}
                        </v-btn>
                    </v-list>
                </v-flex>
            </v-flex>
        </v-card>
    </v-flex>
</template>

<script>
    import { mapActions, mapGetters } from "vuex";
    import { communityCommonConstant } from "../communityCommon.constant";
    import { storeAction } from "../../../store/storeActions.constant";
    import { storeGetters } from "../../../store/storeGetters.constant";
    import { imageErrorFallback } from "../../../common/utils/utils";

    export default {
        name: "CommentedUsers",
        data() {
            return {
                showMemberProfile: false,
                communityCommonConstant,
            };
        },
        props: {
            postId: {
                type: String,
                required: true,
            },
            userHasCommented: {
                type: Boolean,
                required: true,
            },
            commentCount: {
                type: Number,
                required: true,
            },
            dialogState: {
                type: Object,
                default: () => ({}),
            },
        },
        created() {
            this.clearCommentedUsersList();
            this.getCommentedUsersList(this.postId);
            this.displayViewProfile();
        },
        methods: {
            ...mapActions({
                getCommentedUsersList: `chapter/${storeAction.getCommentedUsers}`,
                getChapterAdmin: `memberProfile/${storeAction.getChapterAdmin}`,
                handleLaunchOfMemberProfile: `memberProfile/${storeAction.handleLaunchOfMemberProfile}`,
            }),
            imageErrorFallback,
            displayViewProfile() {
                if (!this.userHasCommented && this.commentCount === 1) {
                    this.showMemberProfile = true;
                    return true;
                }
                return false;
            },
            closeDialog() {
                this.dialogState.dialogOpen = false;
            },
            clearCommentedUsersList() {
                //this.commentedUsers = null;
            },
            openMemberProfile(id) {
                this.handleLaunchOfMemberProfile({
                    memberId: id,
                    name: this.communityInfo && !this.$route.name.includes('home') ? this.communityInfo.name : this.communityCommonConstant.YPO_HOME,
                    router: this.$router,
                });
            },
        },
        computed: {
            ...mapGetters({
                commentedUsers: `chapter/${storeGetters.commentedUsers}`,
                communityInfo: `chapter/${storeGetters.communityInfo}`,
                chapterAdmin: `memberProfile/${storeGetters.chapterAdmin}`,
                currentUserId: `memberProfile/${storeGetters.currentUserId}`,
            }),
        },
    };
</script>

<style lang="scss">
    @import "../../../common/styles/_colors.scss";
    @import "../../../common/styles/_responsive.scss";

    .commeted_users {
        &__list {
            margin: 0 15px;
            padding: 0;

            .v-list__tile {
                padding: 0 0 20px 0;
                height: auto;
                border-bottom: 1px solid $ypo-title-border;
                margin: 0 0 15px 0;

                &__title {
                    font-size: 14px;
                    color: $ypo-gray-text;
                    font-weight: 700;

                    strong {
                        width: 70%;
                        display: inline-block;
                        vertical-align: middle;
                        padding-right: 10px;
                    }

                    span {
                        color: rgba($ypo-gray-text, 0.7);
                        font-weight: 400;
                        font-size: 14px;
                    }
                }

                &__sub-title {
                    font-size: 12px;
                    margin-top: 5px;
                    color: rgba($ypo-gray-text, 0.7);
                }
            }
        }

        &__viewProfile {
            color: $white !important;
            background-color: $ypo-blue !important;
            left: 150px;
        }

        &__inner__scroll {
            overflow: auto;
            max-height: 80vh;
            position: relative;
            padding: 15px 0;
        }

        &__close {
            position: relative;

            .v-btn {
                position: absolute;
                right: -5px;
                z-index: 1;
                top: -20px;
            }
        }

        .v-card {
            border-radius: 4px;
            box-shadow: none;
        }
    }

    .button {
        margin-left: 180px !important;
        background-color: $ypo-blue !important;
        color: $white !important;
    }
</style>
